
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "renameAreaOnScenario",
      resolverType: "mutation",
      routePath: "/renameAreaOnScenario",
      httpMethod: "POST",
    });
  